import React from 'react';
import classes from './form.module.css';

const Form = ({ children }) => {
  return <form className={classes.container}>{children}</form>;
};

export default Form;
